<template>
  <div
    id="SystemDevelopmentDivisionTerimel"
    :style="{
      width: '1920px',
      height: '1080px',
      'transformOrigin':'left top',
      'transform':`scale(${scalseNum})`,
      '-webkit-transform':`scale(${scalseNum})`,
      '-moz-transform':`scale(${scalseNum})`,
      '-o-transform':`scale(${scalseNum})`,
      '-ms-transform':`scale(${scalseNum})`
    }"
  >
    <div class="header main-header">
      <div class="header-left">
        <div class="site-name xx">
          项目支撑情况
        </div>
        <span class="xx">更新时间：{{ cutOffDate }}</span>
      </div>
      <div class="header-right">
        <span class="goback" @click="goback">返回</span>
      </div>
    </div>
    <div class="main-body">
      <c-block-box title="近3月项目支撑情况">
        <project-list :project="mfData.projects"></project-list>
      </c-block-box>
    </div>
  </div>
</template>

<script>
import scalseNum from '@/mixins/scalseNum.js'
import ProjectList from '../components/ProjectList'

export default {
  mixins: [scalseNum],
  name: '',
  props: [

  ],
  data () {
    return {
      cutOffDate: '',
      mfData: {}
    }
  },
  computed: {

  },
  created () {
    this.getProject()
  },
  mounted () {
    this.cutOffDate = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
  },
  watch: {

  },
  methods: {
    getProject () {
      const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
      const isAndroid = this.$store.state.app.isAndroid
      this.barLine = []
      this.$service.fetch({
        url: 'api/media/dashboard_new',
        method: 'get',
        params: {
          yearMonth
        }
      }).then(res => {
        this.$set(this, 'mfData', res)
      })
    },

    goback () {
      window.history.go(-1)
    }
  },
  activated () {
    this.getProject()
  },
  components: {
    ProjectList
  }
}
</script>

<style scoped lang="stylus">
#SystemDevelopmentDivisionTerimel
  >>>
    .business-box
      height:40rem
.main-header
  width 100%
  color #fff
  background #1A1939
  height 3.2rem
  display flex
  padding  0 1rem
  .header-left
    font-size 1.2rem
    height 3.2rem
    line-height 3.2rem
    color #FFFFFF
    flex 1
    .xx
      float left
    .logo
      background-repeat no-repeat
    img
      display inline-block
      margin-right .3rem
      vertical-align text-bottom
      height 1.1rem
    span
      font-size .8rem
      color rgba(255,255,255,.6)
      padding-left .5rem
  .header-right
    width 100px
    display: inline-block
    align-self center
    cursor pointer
.main-body
  padding 1rem
  padding-bottom 0
  // margin-top 1rem
  // height calc(100vh - 4.2rem)
  // width calc(100vw - 2rem)
  // margin 1rem auto 0 auto
  // overflow hidden
</style>
